// extracted by mini-css-extract-plugin
export default {"action-search-input":"ActionsTab_action-search-input__k4CJE","action-list":"ActionsTab_action-list__1SPyU","loading-value":"ActionsTab_loading-value__-M2J0"};